

import { Islands, Obstructions, Vertex3 } from '@rta/rta-blueprint-library';

import { ComponentController } from '../../core/controller/component-controller.class';
import { RenderObstructionOverhead } from '../render/render-obstruction-overhead';

export const showOverheadObstructions = (obstructions: Obstructions, controller: ComponentController): React.ReactElement => {
	const { options } = controller;
	const connectionLinks = [];

	// Check if obstructions should be shown (default to true for backward compatibility)
	const showObstructions = options.showObstructions ?? true;

	const sortedIslandElements = showObstructions ? obstructions.children
		.map((obstruction) => {
			const islandId = obstruction.id;
			const { origin, axis } = obstruction;
			const panel = obstruction.frontPanel;

			// const sourceConnections = obstruction.connections.getSourceConnections();
			// if (sourceConnections.length > 0 && sourceConnections[0].padding >= 0) {
			// 	const [{ sourcePanel, targetIsland }] = sourceConnections;
			// 	const targetOrigin1 = targetIsland?.origin;
			// 	const sourcePoint = sourceConnections[0].getSourcePoint()
			// 		.rotateAxis(new Vertex3(), axis.y, 'y')
			// 		.add(origin);
			// 	const targetPoint = sourceConnections[0].getTargetPoint()
			// 		.rotateAxis(new Vertex3(), targetIsland.axis.y, 'y')
			// 		.add(targetOrigin1);
			// 	const actionPoint = { x: (sourcePoint.x + targetPoint.x) / 2, y: (sourcePoint.z + targetPoint.z) / 2 };

			// 	connectionLinks.push(<g key={`${islandId}-connection`}>
			// 		{/* <circle cx={sourcePoint.x} cy={sourcePoint.z} r=".25" fill="black" /> */}
			// 		<line x1={sourcePoint.x} y1={sourcePoint.z} x2={targetPoint.x} y2={targetPoint.z} stroke="black" strokeWidth=".125" strokeDasharray={0.5} />

			// 		<IslandConnectionActions panelId={sourcePanel.id} offset={{ x: actionPoint.x, y: actionPoint.y }} />
			// 	</g>);
			// }

			const node = <g key={`obstruction-${islandId}`} fill="blue"

			transform={`
				translate(${obstruction.center.x}, ${obstruction.center.z})
				rotate(${obstruction.axis.y})
			`}>
				{/* <CreateCountertopPattern countertop={obstruction.getCountertop()} options={options} />
				<CreateCornerPattern material={obstruction.refMap?.kitchen?.material ?? null} options={options} /> */}
				<RenderObstructionOverhead islandId={ obstruction.id }/>

				{ /* developer mode: obstruction */ }
				{ options.showDeveloperInsights && <>
					{/* light green - rotation point for group */}
					<circle cx={'0'} cy={'0'} r="1.0" fill="red" opacity={0.75}/>

					{ /* green - center point of the group */ }
					<circle cx={`${obstruction.islandSize.width / -2}`} cy={`${obstruction.islandSize.depth / 2}`} r="0.5" fill="green" opacity={0.75}/>


					{ /* dark green - outside corner points */ }
					{ panel && (() => {
						const { corners } = panel.getCornerPoints(false, { nearestSixteenth: true, translate: true });
						const [p1, p2] = corners;
						return <g key={panel.id}>
							<circle cx={p1.x} cy={p1.z} r="0.5" fill="darkgreen" opacity={0.8}/>
							<circle cx={p2.x} cy={p2.z} r="0.5" fill="darkgreen" opacity={0.8}/>
						</g>;
					})()}

					{ /* light green - inside corner points */ }
					{ panel && (() => {
						const { corners } = panel.getCornerPoints(null, { nearestSixteenth: true, translate: true });
						const [p1, p2] = corners;
						return <g key={panel.id}>
							<circle cx={p1.x} cy={p1.z} r="0.3" fill="lightgreen" opacity={0.8}/>
							<circle cx={p2.x} cy={p2.z} r="0.3" fill="lightgreen" opacity={0.8}/>
						</g>;
					})()}

					{ /* red - trim origin */ }
					{/* { obstruction.panelTrims.children.map((panelTrim) => {
						const ptOrigin = panelTrim.origin;
						return <circle key={panelTrim.id} cx={ptOrigin.x} cy={ptOrigin.z} r=".25" fill="red" />
					})} */}

					{/* green - obstruction origin */}
					<circle cx={0} cy={0} r="0.8" fill="green" opacity={0.75}/>
				</>}
			</g>;

			return node;
		}) : [];

	return <g key={`${controller.kitchen.id}-obstructions`}>
		{sortedIslandElements}
		{connectionLinks}
	</g>;
};
